import React, { useState, useMemo } from "react";
import { Layout, Typography, Card, Row, Col, Button, Tag, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const resources = [
  {
    id: 1,
    title: "AI Fundamentals - Introduction to Machine Learning",
    type: "Tutorial",
    description: "A beginner's guide to understanding machine learning concepts, algorithms, and applications.",
    link: "#",
  },
  {
    id: 2,
    title: "Data Science with Python - Essential Skills",
    type: "Article",
    description: "Learn how to use Python for data analysis, data visualization, and machine learning.",
    link: "#",
  },
  {
    id: 3,
    title: "Introduction to Cybersecurity - Best Practices",
    type: "Video",
    description: "A video guide to understanding the basics of cybersecurity and how to protect your systems.",
    link: "#",
  },
  {
    id: 4,
    title: "AI in Real-World Applications - Case Studies",
    type: "Article",
    description: "Explore real-world applications of AI across different industries and how it's changing the landscape.",
    link: "#",
  },
  {
    id: 5,
    title: "Hands-On AI Projects - Learn By Doing",
    type: "Tutorial",
    description: "Work on AI projects and gain practical experience with real datasets and challenges.",
    link: "#",
  },
  {
    id: 6,
    title: "Advanced Cybersecurity Threats and Solutions",
    type: "Article",
    description: "Understand the latest cybersecurity threats and how to defend against them with advanced solutions.",
    link: "#",
  },
];

const ResourceCenter = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredResources = useMemo(() => {
    const query = searchQuery.toLowerCase();
    return resources.filter(
      (resource) =>
        resource.title.toLowerCase().includes(query) ||
        resource.description.toLowerCase().includes(query)
    );
  }, [searchQuery]);

  return (
    <Layout>
      <Content style={{ padding: "50px", background: "#f0f2f5" }}>
        <Title level={2} style={{ fontSize: "24px", color: "#1890ff" }}>
          Resource Center
        </Title>
        <Paragraph style={{ fontSize: "16px", color: "#666", marginBottom: "24px" }}>
          Welcome to the Resource Center! Here, you’ll find a curated collection of tutorials, articles, videos, and more to help you advance your skills in AI, Cybersecurity, and Data Science.
        </Paragraph>

        <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
          <Col xs={24} md={12}>
            <Input
              placeholder="Search resources by title or description"
              prefix={<SearchOutlined />}
              size="large"
              value={searchQuery}
              onChange={handleSearchChange}
              style={{ borderRadius: "4px" }}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          {filteredResources.length > 0 ? (
            filteredResources.map((resource) => (
              <Col xs={24} sm={12} md={8} lg={6} key={resource.id}>
                <Card
                  hoverable
                  style={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Title level={4} style={{ marginBottom: "8px", color: "#333" }}>
                      {resource.title}
                    </Title>
                    <Tag color="blue" style={{ marginBottom: "12px" }}>
                      {resource.type}
                    </Tag>
                    <Paragraph style={{ color: "#666", fontSize: "14px" }}>
                      {resource.description}
                    </Paragraph>
                  </div>
                  <Button
                    type="primary"
                    href={resource.link}
                    target="_blank"
                    style={{ backgroundColor: "#1890ff", borderColor: "#1890ff", width: "100%" }}
                  >
                    Read More
                  </Button>
                </Card>
              </Col>
            ))
          ) : (
            <Col span={24} style={{ textAlign: "center" }}>
              <Paragraph style={{ color: "#999", fontSize: "16px" }}>
                No resources match your search. Try a different query!
              </Paragraph>
            </Col>
          )}
        </Row>
      </Content>
    </Layout>
  );
};

export default ResourceCenter;